module.exports = __webpack_public_path__ + "4a36fb23a9dbb2a2766eb5ff9a24c3c8.jpg";